import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-navy relative overflow-hidden" data-id="element-241">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-turquoise to-transparent opacity-50" data-id="element-242"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-243">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-244">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-turquoise/10 text-turquoise mb-5" data-id="element-245">
            <span className="text-2xl" data-id="element-246">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-white" data-id="element-247">
            The most complete Spanish teaching system for English-speaking
            classrooms
          </h2>
          <h3 className="text-xl font-bold text-turquoise mb-3" data-id="element-248">
            Spanish Ready™ Mega Pack
          </h3>
          <p className="text-base md:text-lg text-white/80 mb-10" data-id="element-249">
            6-in-1 complete system · 5 exclusive bonus packs · Ready to use from
            today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-250">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-navy-dark p-6 rounded-2xl border border-navy-light" data-id="element-251">
            <div className="flex items-start gap-3" data-id="element-252">
              <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-253" />
              <p className="text-white/70 text-sm" data-id="element-254">
                This is not theory copied from a pedagogy textbook.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-255">
              <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-256" />
              <p className="text-white/70 text-sm" data-id="element-257">
                This is not a collection of disconnected activities.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-258">
              <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-259" />
              <p className="text-white/70 text-sm" data-id="element-260">
                This is not material you have to adapt entirely before it works.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-turquoise/10 p-6 rounded-2xl border border-turquoise/30 relative overflow-hidden" data-id="element-261">
            <div className="absolute top-0 right-0 w-32 h-32 bg-turquoise/20 blur-3xl rounded-full" data-id="element-262"></div>
            <div className="flex items-start gap-3 relative z-10" data-id="element-263">
              <Check className="text-turquoise shrink-0 mt-1" size={20} data-id="element-264" />
              <p className="text-white font-medium text-base leading-relaxed" data-id="element-265">
                This is a complete 6-in-1 system so you walk into every
                classroom with confidence and deliver lessons that actually
                teach Spanish.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}